import React from "react";

const OSM_TEXT = "© OpenStreetMap contributors";
const CARTO_TEXT = "© CARTO";
const OSM_URL = "https://www.openstreetmap.org/copyright";
const CARTO_URL = "https://carto.com/attributions";
const MAPLIBRE_URL = "https://maplibre.org/";

interface MapAttributionProps {
  /** `map` for an interactive map (links, with MapLibre); `thumbnail` for a card that is itself a link (plain text). */
  variant?: "map" | "thumbnail";
  className?: string;
}

const LINK = "hover:text-ink hover:underline";

/** The basemap credit for every MapLibre map and thumbnail, bottom-right. Parent must be positioned. */
const MapAttribution: React.FC<MapAttributionProps> = ({ variant = "map", className = "" }) => {
  if (variant === "thumbnail") {
    return (
      <span
        data-testid="map-attribution"
        className={`pointer-events-none absolute bottom-0 right-0 bg-surface/70 px-1 text-[8px] leading-tight text-ink-muted ${className}`}
      >
        {OSM_TEXT} {CARTO_TEXT}
      </span>
    );
  }
  return (
    <div
      data-testid="map-attribution"
      className={`absolute bottom-1 right-1 z-10 rounded bg-surface/80 px-1.5 text-[10px] leading-4 text-ink-muted ${className}`}
    >
      <a href={OSM_URL} target="_blank" rel="noopener noreferrer" className={LINK}>
        {OSM_TEXT}
      </a>{" "}
      <a href={CARTO_URL} target="_blank" rel="noopener noreferrer" className={LINK}>
        {CARTO_TEXT}
      </a>{" "}
      <a href={MAPLIBRE_URL} target="_blank" rel="noopener noreferrer" className={LINK}>
        MapLibre
      </a>
    </div>
  );
};

export default MapAttribution;
